import React, { forwardRef } from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
  gap?: number | string;
  justifyContent?: string;
  alignItems?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const HStack = forwardRef<HTMLDivElement, Props>(
  ({ children, className, gap, justifyContent, alignItems, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`flex flex-row
    ${gap ? `gap-${gap}` : ""}
    ${justifyContent ? `justify-${justifyContent}` : ""}
    ${alignItems ? `items-${alignItems}` : "items-center"} 
    ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);

export default HStack;
